"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useProductListEditValidationSchema = void 0;
var _zod = require("zod");
var _constants = require("../../constants");
const useProductListEditValidationSchema = ()=>{
    const productListEditValidationSchema = _zod.z.object({
        name: _zod.z.string().min(1).max(_constants.MAX_NAME_LENGTH)
    });
    return {
        productListEditValidationSchema
    };
};
exports.useProductListEditValidationSchema = useProductListEditValidationSchema;
